import {
  useQuery,
  useMutation,
  useQueryClient,
  type UseQueryResult,
} from '@tanstack/react-query'
import { destinationsApi } from '@/lib/api'
import type { Destination, DestinationFormData } from '@/types'

export const destinationKeys = {
  all: ['destinations'] as const,
  list: () => [...destinationKeys.all, 'list'] as const,
}

export function useDestinations(): UseQueryResult<Destination[]> {
  return useQuery({
    queryKey: destinationKeys.list(),
    queryFn: async () => {
      const res = await destinationsApi.list()
      return res.data
    },
  })
}

export function useCreateDestination() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: DestinationFormData) =>
      destinationsApi.create(data).then((r) => r.data),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: destinationKeys.list() }),
  })
}

export function useUpdateDestination() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: DestinationFormData }) =>
      destinationsApi.update(id, data).then((r) => r.data),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: destinationKeys.list() }),
  })
}

export function useDeleteDestination() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => destinationsApi.delete(id),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: destinationKeys.list() }),
  })
}
